export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_VENDORS = 'GET_VENDORS';
export const GET_SHOPPERS = 'GET_SHOPPERS';
